import React from "react";
import { Box, Typography } from "@mui/material";
import moment from 'moment';
import { getNormalizedPeriods } from 'src/utils/calendar';

interface WorkingPeriodSectionProps {
  inDrawer?: boolean;
  from: string;
  to: string;
  weekdays: string;
}

function WorkingPeriodSection ({
  inDrawer,
  from,
  to,
  weekdays,
}: WorkingPeriodSectionProps) {
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Typography
          sx={{
            color: "#1F1F1F",
            fontWeight: "700",
            fontSize: inDrawer ? "14px" : "16px",
          }}
        >
          {from}
        </Typography>
        <Typography
          sx={{
            margin: "0px 4px",
            color: "#9D9D9D",
            fontWeight: "400",
            fontSize: inDrawer ? "14px" : "16px",
          }}
        >
          to
        </Typography>
        <Typography
          sx={{
            color: "#1F1F1F",
            fontWeight: "700",
            fontSize: inDrawer ? "14px" : "16px",
          }}
        >
          {to}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        <Typography
          sx={{
            fontSize: inDrawer ? "14px" : "16px",
            color: "#9D9D9D",
            fontWeight: "500",
          }}
        >
          {weekdays}
        </Typography>
      </Box>
    </Box>
  );
}

interface StudioWorkingTimeProp {
  inDrawer?: boolean;
  studio?: any;
  renderImage: boolean;
  customStyle?: any;
  workingTime?: any;
}

export function StudioWorkingTime ({ studio, renderImage, customStyle, inDrawer, workingTime}: StudioWorkingTimeProp) {

  // @ts-ignore
  const image = studio?.images?.[0];

  const period = workingTime?.period;

  const fromDateText = moment(period?.from).format('DD.MM.YY');
  const periodText = `${moment(period?.from).format('DD MMM YYYY')} - ${moment(period?.to).format('DD MMM YYYY')}`;

  const renderWorkingTimes = () => {
    const periodsNormalized = getNormalizedPeriods(workingTime?.daysPeriods);

    return Object.entries(periodsNormalized).map(([key, value]: any) => {
      const [from, to] = key.split('/');
      const weekdays = value.weekdays.join(', ');

      return (
        <WorkingPeriodSection
          inDrawer={inDrawer}
          key={key}
          from={from}
          to={to}
          weekdays={weekdays}
        />
      );
    });
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        width: "100%",
        backgroundColor: "#FAFAFA",
        borderBottom: "2px solid #BF295C",
        borderBottomLeftRadius: "6px",
        borderBottomRightRadius: "6px",
        marginBottom: "16px",
        ...customStyle
      }}
    >

      {renderImage &&
        <Box sx={{
          borderRadius: '6px',
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
          overflow: 'hidden',
        }}>
          <img
            src={image}
            loading="lazy"
            style={{
              width: '100%',
              height: 142,
              objectFit: 'cover',
            }}
          />
        </Box>
      }

      <Box
        sx={{
          padding: "12px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{maxWidth: "50%"}}>
            <Typography
              sx={{
                fontSize: inDrawer ? "12px" : "14px",
                color: "#9D9D9D",
              }}
            >
              Studio
            </Typography>
            <Typography
              sx={{
                fontSize: inDrawer ? "14px" : "16px",
                color: "#1F1F1F",
                fontWeight: 700,
                wordWrap: 'break-word',
              }}
            >
              {studio?.title}
            </Typography>
            <Typography
              sx={{
                fontSize: inDrawer ? "14px" : "16px",
                color: "#9D9D9D",
                fontWeight: 500,
                textTransform: "uppercase",
                wordWrap: 'break-word',
              }}
            >
              {studio?.address}
            </Typography>
          </Box>
          <Box sx={{maxWidth: "50%"}}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <Typography
                sx={{
                  fontSize: inDrawer ? "12px" : "14px",
                  color: "#9D9D9D",
                }}
              >
                Regular hours
              </Typography>
            </Box>
            {renderWorkingTimes()}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            borderTop: "1px solid #E8E8E8",
            marginTop: "7px",
            paddingTop: '7px',
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                fontSize: inDrawer ? "14px" : "16px",
                fontWeight: "400",
                color: "#9D9D9D",
              }}
            >
              From
            </Typography>
            <Typography
              sx={{
                color: "#1F1F1F",
                fontWeight: "500",
                fontSize: inDrawer ? "14px" : "16px",
              }}
            >
              {fromDateText}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <Typography
              sx={{
                fontSize: inDrawer ? "14px" : "16px",
                fontWeight: "400",
                color: "#9D9D9D",
              }}
            >
              Period
            </Typography>
            <Typography
              sx={{
                color: "#1F1F1F",
                fontWeight: "500",
                fontSize: inDrawer ? "14px" : "16px",
              }}
            >
              {periodText}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
